export default "__VITE_ASSET__L2ndJ0Vt__"